export interface ConfigTypeOption {
  name: string
  value: string
}

// Single source of truth for the sensor configuration-type display labels,
// shared by the sensors grid (value -> label lookup) and the filter dropdown.
export const configTypeLabels: Record<string, string> = {
  default: 'Default',
  default_not_matches: 'Default (not matches)',
  custom: 'Custom',
  unknown: 'Unknown'
}

export const configTypeFilterOptions: ConfigTypeOption[] = [{ name: 'All', value: 'all' }, ...Object.entries(configTypeLabels).map(([value, name]) => ({ value, name }))]
